import { Button, Col, Divider, Form, Input, Row, Upload } from "antd";
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import type { UploadFile } from 'antd/es/upload/interface';
import helper from "../../utils/helper";

interface Props {
    editAllInfo: boolean,
    create?: boolean,
    imageFile: UploadFile[] | string,
    normFile: (e: any) => any,
    dataFile: { beforeUpload: (file: { size: any, name: string; }) => boolean | typeof Upload.LIST_IGNORE },
    deleteOldLogo: () => void,
}

export default function ContactLocationSection(props: Props) {
    const {
        editAllInfo,
        create,
        imageFile,
        normFile,
        dataFile,
        deleteOldLogo,
    } = props;

    return (
        <>
            <Divider orientation="left">Contact & Location</Divider>
            <Row gutter={[12, 0]} style={{ marginBottom: '12px' }}>
                <Col span={8}>
                    <label htmlFor="">Contact Information <span>*</span></label>
                    <Form.Item name="contactInformation" validateFirst rules={[helper.notOnlySpacesRule, { required: create || editAllInfo, message: 'Required' }]}>
                        <Input placeholder='Please enter contact information' disabled={!editAllInfo} />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <label htmlFor="">National Address <span>*</span></label>
                    <Form.Item name="nationalAddress" validateFirst rules={[helper.notOnlySpacesRule, { required: create || editAllInfo, message: 'Required' }]}>
                        <Input placeholder='Please enter national address' disabled={!editAllInfo} />
                    </Form.Item>
                </Col>
                {(!imageFile || typeof imageFile !== "string") && create && <Col span={8}>
                    <label htmlFor="">Upload Logo <span>*</span></label>
                    <Form.Item
                        name="logo"
                        valuePropName="fileList"
                        getValueFromEvent={normFile}
                        rules={[{ required: true, message: 'Required' }]}
                    >
                        <Upload {...dataFile} maxCount={1} name="logo" action="/upload.do" listType="picture" accept='.png,.jpg,.jpeg'>
                            <Button icon={<UploadOutlined />}>Click to upload the logo</Button>
                        </Upload>
                    </Form.Item>
                </Col>}

                {imageFile && typeof imageFile === "string" &&
                    <Col span={8}>
                        <div className="oldPhoto">
                            <img src={imageFile} alt="Logo" width={34} height={50} />
                            <span className="placeholder">Logo</span>
                            {create && <span className="deleteIcon">
                                <DeleteOutlined onClick={deleteOldLogo} />
                            </span>}
                        </div>
                    </Col>
                }
            </Row>
        </>
    )
}
